import { render, staticRenderFns } from "./authorPerson.vue?vue&type=template&id=dc6ceedc&scoped=true&"
import script from "./authorPerson.vue?vue&type=script&lang=js&"
export * from "./authorPerson.vue?vue&type=script&lang=js&"
import style0 from "./authorPerson.vue?vue&type=style&index=0&id=dc6ceedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6ceedc",
  null
  
)

export default component.exports